module.exports = __webpack_public_path__ + "img/dashboard-icon.f04247da.svg";